import { ZCatalogClassifierItem } from "src/business/catalog/ZCatalog";
import {
  applyRequest,
  makeFilters,
  testStrPart,
} from "src/components/ReactiveTable/loaders/clientDataCtrl";
import {
  cvtInsensitive,
  strFieldSorter,
} from "src/components/ReactiveTable/loaders/clientDataCtrl/customSorters";
import { RtRequest } from "src/components/ReactiveTable/RtRequest";
import { RtResponse } from "src/components/ReactiveTable/RtResponse";

export type LocalClassifiersFilter = {
  name?: string;
  description?: string;
};

export type LocalClassifierLoader = {
  setData(values: ZCatalogClassifierItem[]): void;
  load(
    request: RtRequest<LocalClassifiersFilter>,
  ): Promise<RtResponse<ZCatalogClassifierItem>>;
};

export const createLocalClassifierLoader = (): LocalClassifierLoader => {
  let clsData: ZCatalogClassifierItem[] = [];
  return {
    setData(newData) {
      clsData = newData;
    },
    async load(
      request: RtRequest<LocalClassifiersFilter>,
    ): Promise<RtResponse<ZCatalogClassifierItem>> {
      const res = applyRequest(clsData, request, {
        sorters: {
          name: strFieldSorter("name", cvtInsensitive),
          description: (a, b) => nullableStrCmp(a.description, b.description),
        },
        isFiltered: makeFilters<ZCatalogClassifierItem, LocalClassifiersFilter>(
          {
            name: testStrPart("name", true),
            description: testStrPart("description", true),
          },
        ),
      });
      return res;
    },
  };
};

const nullableStrCmp = (
  a: string | null | undefined,
  b: string | null | undefined,
): number => {
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;
  return cvtInsensitive(a).localeCompare(cvtInsensitive(b));
};
